import React, { FC } from 'react';

import * as CSS from './availability.styles';
import { MonthWithWeeks, TableCell, Week } from '../../utils/bookings/booking-types';

const monthNames = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'];
type MonthProps = {
  year: number;
  month: MonthWithWeeks;
};

const Month: FC<MonthProps> = ({ year, month }) => {
  return (
    <CSS.CarouselItem key={`${year}-${month.name}`}>
      <CSS.MonthContainer>
        <tbody>
          <tr>
            <th colSpan={7}>{`${month.name} ${year}`}</th>
          </tr>
          <tr>
            <CSS.DayTitle>Mon</CSS.DayTitle>
            <CSS.DayTitle>Tue</CSS.DayTitle>
            <CSS.DayTitle>Wed</CSS.DayTitle>
            <CSS.DayTitle>Thu</CSS.DayTitle>
            <CSS.DayTitle>Fri</CSS.DayTitle>
            <CSS.DayTitle>Sat</CSS.DayTitle>
            <CSS.DayTitle>Sun</CSS.DayTitle>
          </tr>
          {month.weeks.map((week: Week, index: number) => {
            const key = `year-${year}-month-${month.name}-week-${index}`;
            return (
              <tr key={key}>
                {week.map((cell: TableCell, cellIndex: number) => {
                  const cellKey = `${key}-cell-${cellIndex}`;
                  switch (cell.status) {
                    case 'aa': //available all day
                      return <CSS.AAday key={cellKey}>{cell.day}</CSS.AAday>;
                    case 'as': // available / booking start
                      return <CSS.ASday key={cellKey}>{cell.day}</CSS.ASday>;
                    case 'es': //booking end / booking start
                      return <CSS.ESday key={cellKey}>{cell.day}</CSS.ESday>;
                    case 'ea': //booking end / available
                      return <CSS.EAday key={cellKey}>{cell.day}</CSS.EAday>;
                    case 'bb': // booked all day
                      return <CSS.BBday key={cellKey}>{cell.day}</CSS.BBday>;
                    default: // clear day (not calendar day)
                      return <CSS.Cday key={cellKey}>{cell.day}</CSS.Cday>;
                  }
                })}
              </tr>
            );
          })}
        </tbody>
      </CSS.MonthContainer>
    </CSS.CarouselItem>
  );
};

export default Month;
